import { Select, TextInput } from "risa-oasis-ui_v2";
import { HealthCareFacilityModel } from "../../../../data-model/healthFacility";
import { getStateLabelValueArray } from "../../../../../shared/enums/usStates";

interface AddressDetailsSectionProps {
  facilityData: HealthCareFacilityModel;
  resetFormData: boolean;
  handleChangeForAddressDetails: (data: any) => void;
}

const AddressDetailsSection = (props: AddressDetailsSectionProps) => {
  return (
    <fieldset>
      <legend>Address Details of Facility</legend>
      <TextInput
        id={"StreetAddress"}
        label={"Street Address"}
        required
        onChange={props.handleChangeForAddressDetails}
        error={
          props.facilityData?.Address?.StreetAddress === ""
            ? "Please provide a street address"
            : ""
        }
        resetField={props.resetFormData}
        defaultValue={props.facilityData?.Address?.StreetAddress}
      />
      <TextInput
        id={"City"}
        label={"City"}
        required
        onChange={props.handleChangeForAddressDetails}
        error={
          props.facilityData?.Address?.City === ""
            ? "Please provide a city"
            : ""
        }
        resetField={props.resetFormData}
        defaultValue={props.facilityData?.Address?.City}
      />
      <Select
        id={"State"}
        onOptionChange={props.handleChangeForAddressDetails}
        label={"State"}
        placeholder={"Select a state ..."}
        options={getStateLabelValueArray()}
        required
        error={
          props.facilityData?.Address?.State === ""
            ? "Please select a state"
            : ""
        }
        resetValue={props.resetFormData}
        defaultValue={props.facilityData?.Address?.State}
      />
      <TextInput
        id={"ZIP"}
        label={"Zip Code"}
        required
        onChange={props.handleChangeForAddressDetails}
        error={
          props.facilityData?.Address?.ZIP === ""
            ? "Please provide a zip code"
            : ""
        }
        resetField={props.resetFormData}
        defaultValue={props.facilityData?.Address?.ZIP}
      />
    </fieldset>
  );
};

export default AddressDetailsSection;
